<nb-accordion [multi]="item.multiple">
  <nb-accordion-item *ngFor="let tab of item.tabs" [expanded]="tab.expanded">
    <nb-accordion-item-header>
      <div [innerHTML]="tab.translation_key||tab.heading| translation|
      translationFromString|translationFromString | transformText :tab?.text_transform|safeHtml"></div>
    </nb-accordion-item-header>
    <nb-accordion-item-body>
      <div>
        <app-rendered
          [childview]="item.childview || childview"
          [paramprefix]="item.paramprefix"
          [info]="info"
          *ngFor="let it of tab.content"
          [item]="it" [arr]="tab.content"
          [data]="data"
          (deleteDataEvent)="delete($event)"
          (openViewEvent)="openView($event)"
          (moveHandler)="openMove()"
          (openLinkEvent)="openLink($event)"
          [collapsed]="tab.collapsed">
        </app-rendered>
      </div>
    </nb-accordion-item-body>
  </nb-accordion-item>
</nb-accordion>
